import $ from 'jquery';
import '../global';
import animateTheHeroText from '../animations/animateHeroText';
import animateScroll from '../animations/scrollAnimations';
import SliderAnimation from '../animations/sliderAnimation';
import 'slick-carousel/slick/slick';
import bowser from 'bowser/bowser';


$(document).ready( function() {
  instagramFeedSlider();
  scrollToContent();
  animateScroll().clockAnimation();
  const homepageSliderAnimation = new SliderAnimation(8000).initiateSlider();
  $('.hero-slider').slick("setOption", "autoplaySpeed", 4000);

  if(bowser.osname == 'iOS') {
    $('.hero-slider .slick-dots li').css('margin-left','0');
    $('.image-slider .slick-dots li').css('margin-left','0');
    $('.hero-slider .slick-dots .slick-next').css('margin-left','0');
  }

  $('.image-slider').slick({
    dots: true,
    infinite: true,
    speed: 500,
    fade: true,
    cssEase: 'linear',
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    pauseOnFocus: false
  });

  $('.image-slider .slick-dots button').text('');
  $('.image-slider .slick-next').insertAfter('.slick-dots li:last-of-type');
  $('.image-slider .slick-prev').insertBefore('.slick-dots li:first-of-type');
  $('.image-slider .slick-next').text('');
  $('.image-slider .slick-prev').text('');
  $('.image-slider .slick-dots li button').prop('disabled', true);
});

function scrollToContent() {
  $('.hero .hero-button a,.hero .arrow-down').click(function(e) {
    e.preventDefault();
    var elemID = $('.hero-button a').attr('href');
    $('body').removeClass('no-scroll');
    $('html, body').animate({
      scrollTop: $(elemID).offset().top
    }, 1000);
  });
}

function instagramFeedSlider() {
  $('.instagram-feed').slick({
    infinite: true,
    slidesToShow: 4,
    dots: false,
    prevArrow: '<div class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.58216 49.56816"><path d="M24.87506.70711.70711,24.87506l23.986,23.986"></path></svg></div>',
    nextArrow: '<div class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.58216 49.56816"><path d="M.88906,48.86106l23.986-23.986L.70711.70711"></path></svg></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
